import React from 'react';
import TooltipBody from 'modules/emergencies/components/ui/texts/TooltipBody';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';
import { getUserName } from '../utils/user';

export const AgentAssignedTooltip = ({ disabled, ticket }) => {
  let noAgentText;
  if (disabled) {
    noAgentText = 'Can`t assign';
  } else {
    noAgentText = 'Assign';
  }
  const id = ticket?.assigned_to?.id;
  const user = ticket?.assigned_to || {};
  const head = id ? 'Assigned to' : noAgentText;
  const body = id ? getUserName(user) : '';
  return (
    <>
      <TooltipHeader>{head}</TooltipHeader>
      <TooltipBody>{body}</TooltipBody>
    </>
  );
};
